import { ArrowRightOutlined } from '@ant-design/icons';
import { Display } from '@/components/Display/Display';
import s from './style.module.scss';
import { useEffect, useState } from 'react';
import ChatFile from './components/ChatFile';
import { fileTypeMap } from '@/utils/Page/constant';
import React from 'react';
import MobileImage from './components/Image';
const ChatFiles = (props) => {
    console.log(props, 'ChatFiles');
    const { fileList } = props;
    const [isSingelImg, setIsSingelImg] = useState(false);
    useEffect(() => {
        if (fileList.length === 1 && fileList[0].type === fileTypeMap.img) {
            setIsSingelImg(true);
        } else {
            setIsSingelImg(false);
        }
    }, [fileList]);
    return (
        <>
            <Display show={isSingelImg}>
                <div className={s['single-img-type-wrap']}>
                    <MobileImage file={fileList[0]}></MobileImage>
                </div>
            </Display>
            <Display show={!isSingelImg}>
                <div className={s['files-wrap']} data-from={'chat'}>
                    {fileList.map((ele, index) => {
                        return (
                            <React.Fragment key={index}>
                                <ChatFile index={index} file={ele}></ChatFile>
                            </React.Fragment>
                        );
                    })}
                </div>
            </Display>
        </>
    );
};
export default ChatFiles;
